<template>
  <v-alert
    class="inline-warning-message"
    color="#ff7f32"
    type="warning"
    variant="tonal"
    icon-size="x-small"
    icon="mdi-exclamation-thick"
  >
    <slot>
      {{ message }}
    </slot>
  </v-alert>
</template>

<script>
export default {
  name: 'InlineWarningMessage',
  props: {
    message: {
      type: String,
      required: true
    }
  }
};
</script>
<style scoped>
.inline-warning-message {
  margin-bottom: 10px;
}
</style>
